const productMeasurements = (measurement) => {
    const measurements = {
        sex: { en: "Sex", th: "เพศ" },
        measurement: { en: "Measurement", th: "วัดตัว" },
        frontLength: { en: "Front Length", th: "ยาวหน้า" },
        firstButton: { en: "First Button", th: "กระดุมแรก" },
        chest: { en: "Chest", th: "อก" },
        waistUpper: { en: "Waist Upper", th: "เอวบน" },
        waistLower: { en: "Waist Lower", th: "เอวล่าง" },
        hips: { en: "Hips", th: "สะโพก" },
        shoulders: { en: "Shoulders", th: "ไหล่" },
        sleevesRight: { en: "Sleeves Right", th: "แขนขวา" },
        sleevesLeft: { en: "Sleeves Left", th: "แขนซ้าย" },
        neck: { en: "Neck", th: "คอ" },
        pTPFront: { en: "PTP - Front", th: "บ่าหน้า" },
        pTPBack: { en: "PTP - Back", th: "บ่าหลัง" },
        armHole: { en: "Arm Hole", th: "วงแขน" },
        biceps: { en: "Biceps", th: "ต้นแขน" },
        forearm: { en: "Forearm", th: "ท่อนแขน" },
        wristLeft: { en: "Wrist Left", th: "ข้อมือซ้าย" },
        wristRight: { en: "Wrist Right", th: "ข้อมือขวา" },
        shoulder: { en: "Shoulder", th: "ไหล่" },
        waist: { en: "Waist", th: "เอว" },
        tuxRemarks: { en: "Measurement Remarks", th: "หมายเหตุการวัด" },
        crotchHigh: { en: "Crotch High", th: "เป้าสูง" },
        crotchlow: { en: "Crotch Low", th: "เป้าต่ำ" },
        inseamLength: { en: "Inseam Length", th: "เป้าถึงปลายขา" },
        thighs: { en: "Thighs", th: "โคนขา" },
        knees: { en: "Knees", th: "เข่า" },
        calf: { en: "Calf", th: "น่อง" },
        cuffsAnkle: { en: "Cuffs (Ankle)", th: "ปลายขา" },
        pantRemarks: { en: "Measurement Remarks", th: "หมายเหตุการวัด" },
        chestDrop: { en: "Chest ", th: "ความลึกหน้าอก" },
        fit: { en: "Fit", th: "ความพอดี" },
        frontJacketLength: { en: "Front Jacket Length", th: "ความยาวหน้าแจ็คเก็ต" },
        pantWaist: { en: "Pant Waist", th: "เอวกางเกง" },
        backVestLength: { en: "Back Vest Length", th: "ความยาวด้านหลัง" },
        jacketMeasurement: { en: "Jacket Measurement", th: "วัดตัวแจ็คเก็ต" },
        backJacketLength: { en: "Back Jacket Length", th: "ความยาวด้านหลังแจ็คเก็ต" },
        remarks: { en: "Remarks",  }
    };

    return measurements[measurement] || { en: measurement, th: '' };
};

export default productMeasurements;
